import { makeFilterString } from "../../utils/Helper";
import {
  GetThemesSuccess,
  ThemesLoading,
  SetTheme,
  GetThemeDetailsSuccess,
  GetScrollThemesSuccess,
} from "./Actions";

import { reduxRequest } from "../../../../common/utils/reduxRequest";

export const getThemesRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: ThemesLoading,
    loadingType: "list",
    successFunction: GetThemesSuccess,
    url: `/admin/lookups/themes${makeFilterString(variables?.params)}`,
    method: "get",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getScrollThemesRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: ThemesLoading,
    loadingType: "filter-list-themes",
    successFunction: GetScrollThemesSuccess,
    url: `/admin/lookups/themes${makeFilterString(variables?.params)}`,
    method: "get",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const createThemeRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: ThemesLoading,
    loadingType: "add",
    successFunction: SetTheme,
    action: variables?.action,
    url: `/admin/lookups/themes`,
    method: "post",
    data: variables?.body,
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getThemeDetailsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: ThemesLoading,
    loadingType: "details",
    successFunction: GetThemeDetailsSuccess,
    url: `/admin/lookups/themes/${variables?.id}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const deleteThemeRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: ThemesLoading,
    loadingType: "delete theme",
    action: variables?.action,
    url: `/admin/lookups/themes/${variables?.id}`,
    method: "delete",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const updateThemeRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: ThemesLoading,
    loadingType: "update theme",
    url: `/admin/lookups/themes/${variables?.id}`,
    action: variables?.action,
    data: variables?.body,
    method: "put",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};
